import { render, staticRenderFns } from "./option-details.vue?vue&type=template&id=11d653d0&scoped=true&"
import script from "./option-details.vue?vue&type=script&lang=js&"
export * from "./option-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d653d0",
  null
  
)

export default component.exports